var map = {
	"./alerts.json": "./src/locales/fr/alerts.json",
	"./changelogs.json": "./src/locales/fr/changelogs.json",
	"./common.json": "./src/locales/fr/common.json",
	"./csv.json": "./src/locales/fr/csv.json",
	"./custom.json": "./src/locales/fr/custom.json",
	"./dashboards.json": "./src/locales/fr/dashboards.json",
	"./data_types.json": "./src/locales/fr/data_types.json",
	"./descriptions.json": "./src/locales/fr/descriptions.json",
	"./devices.json": "./src/locales/fr/devices.json",
	"./documents.json": "./src/locales/fr/documents.json",
	"./errors.json": "./src/locales/fr/errors.json",
	"./export.json": "./src/locales/fr/export.json",
	"./forms.json": "./src/locales/fr/forms.json",
	"./graphs.json": "./src/locales/fr/graphs.json",
	"./groups.json": "./src/locales/fr/groups.json",
	"./highcharts.json": "./src/locales/fr/highcharts.json",
	"./logs.json": "./src/locales/fr/logs.json",
	"./messaging.json": "./src/locales/fr/messaging.json",
	"./notifications.json": "./src/locales/fr/notifications.json",
	"./passages.json": "./src/locales/fr/passages.json",
	"./rounds.json": "./src/locales/fr/rounds.json",
	"./search.json": "./src/locales/fr/search.json",
	"./settings.json": "./src/locales/fr/settings.json",
	"./subscriptions.json": "./src/locales/fr/subscriptions.json",
	"./tickets.json": "./src/locales/fr/tickets.json",
	"./users.json": "./src/locales/fr/users.json",
	"./workspace.json": "./src/locales/fr/workspace.json",
	"./workspaces.json": "./src/locales/fr/workspaces.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/fr sync recursive ^\\.\\/.*\\.json$";